/**
 * Global Entry Point
 * Loads on all pages: finish selector, footer avoidance, and lazy widget integrations.
 */

import "../types/shopify.d";
import "../modules/finish-selector";
import { onDOMReady } from "../lib/dom";
import { initChatwootWidget } from "../modules/chatwoot-widget";
import { initFancyboxLoader } from "../modules/fancybox-loader";
import { initFooterAvoidance } from "../modules/footer-avoidance";
import { initHeaderWishlist } from "../modules/header-wishlist";
import { initReviewsTab } from "../modules/reviews-tab";
import { initTurnaroundLoader } from "../modules/turnaround-loader";

initFooterAvoidance();
initTurnaroundLoader();
initFancyboxLoader();

onDOMReady(() => {
  initChatwootWidget();
  initHeaderWishlist();
  initReviewsTab();
});
